import { render, staticRenderFns } from "./ConfigAlertPagerDuty.vue?vue&type=template&id=7810b826&scoped=true"
import script from "./ConfigAlertPagerDuty.vue?vue&type=script&lang=js"
export * from "./ConfigAlertPagerDuty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7810b826",
  null
  
)

export default component.exports